import { type ProductOption } from "@kanpla/api-contract";
import { cva } from "class-variance-authority";

import { T } from "@repo/transifex";

import { getVariantHintMessage } from "./get-variant-hint-message";

const variantHintStyles = cva("text-sm", {
  variants: {
    error: {
      false: "text-interface-neutral-5",
      true: "text-interface-negative-2"
    }
  }
});

type VariantHintProps = {
  minimum: ProductOption["minimum"];
  maximum: ProductOption["maximum"];
  error: boolean;
};

export const VariantHint = ({ minimum, maximum, error }: VariantHintProps) => {
  const message = getVariantHintMessage({ minimum, maximum });
  if (!message) return null;

  return (
    <p className={variantHintStyles({ error })}>
      <T _str={message.key} {...(message.values ?? {})} />
    </p>
  );
};
